<template>
    <div class="settledPage">
        <BookingBack title='Onboarding Application' :isDark="true" :isCenter="true"/>
        <div class="settledForm">
            <!-- 顶部状态卡片（参考截图） -->
            <van-form @submit="onSubmit">
                <div class="formCard">
                    <!-- 审核通过时：成功Notice放在表单卡片顶部（不单独成块） -->
                    <div v-if="status === 1" class="successCard successCard--inline">
                        <div class="successIconOuter">
                            <div class="successIconInner">
                                <!-- UsePayment Successful同款 icon -->
                                <van-icon name="success" size="36" color="#fff" />
                            </div>
                        </div>
                        <div class="successText">Congratulations! Your onboarding application is complete.</div>
                    </div>
                    <van-field
                        v-model="form.store_name"
                        name="store_name"
                        class="fieldInput"
                        :placeholder="status === null ? 'Enter store name' : ''"
                        :readonly="isReadonly"
                        :required="!isReadonly"
                        :rules="isReadonly ? [] : [{ required: true }]"
                    />
                    <div class="uploaderBox">
                        <div class="uploaderHeader">
                            <div class="uploaderlabel">Business License</div>
                            <!-- 右侧状态文案按需求移除（仅保留布局占位） -->
                            <div class="uploaderStatusSpacer"></div>
                        </div>
                        <van-field vertical name="business_id" :rules="isReadonly ? [] : [{ required: true }]" v-model="form.business_id">
                            <template v-slot:input>
                                <van-uploader
                                    :after-read="afterRead"
                                    v-model="fileList"
                                    :max-count="1"
                                    :max-size="5000 * 1024"
                                    @oversize="onOversize"
                                    :disabled="isReadonly"
                                    :deletable="!isReadonly"
                                />
                            </template>
                        </van-field>
                    </div>
                    <van-field
                        v-model="form.tax_num"
                        name="tax_num"
                        class="fieldInput"
                        :placeholder="status === null ? 'Tax ID' : ''"
                        :readonly="isReadonly"
                        :required="!isReadonly"
                        :rules="isReadonly ? [] : [{ required: true }]"
                    />
                    <van-field
                        v-model="form.bank_account"
                        name="bank_account"
                        class="fieldInput"
                        :placeholder="status === null ? 'Bank Account' : ''"
                        :readonly="isReadonly"
                        :required="!isReadonly"
                        :rules="isReadonly ? [] : [{ required: true }]"
                    />
                </div>
                <!-- 未申请或Refill状态显示提交按钮 -->
                <van-button v-if="status === null" block type="info" color="#1E3C3E" native-type="submit">Submit for Review</van-button>
                <!-- 审核中Notice（保留逻辑，样式更贴近截图） -->
                <div v-else-if="status === 0" class="auditHint">Under review, please wait.</div>
            </van-form>
            <div v-if="status === 2">
                <div class="failError">
                    <div class="failTitle">Review Failure Reason</div>
                    <div>{{ detail.content || 'Review not passed. Please resubmit.' }}</div>
                </div>
                <div class="refreshBtn" @click="handleRefresh">Refill</div>
            </div>
            <div v-if="status !== 2" class="remark">
                By submitting, you agree to
                <span class="remarkAgreement" @click="handleOpenMerchantAgreement">Onboarding Agreement</span>
            </div>
        </div>
        <van-popup
            v-model="showAgreementPopup"
            closeable
            round
            close-icon-position="top-right"
            position="bottom"
            :style="{ height: '70%' }"
        >
            <div class="agreement">
                <div class="agreementTitle">Onboarding Agreement</div>
                <div v-if="agreementLoading" class="agreementLoading">Loading...</div>
                <div v-else class="agreementBody" v-html="agreementHtml"></div>
            </div>
        </van-popup>
    </div>
</template>
<script>
import BookingBack from '@/components/Booking/back.vue'
import { Toast } from 'vant'
import myMixin from '@/utils/myMixin';
export default {
    name:'ShopSettled',
    data(){
        return {
            form:{
                store_name:'',
                tax_num:'',
                bank_account:'',
                business_id:''
            },
            status:null,
            fileList:[],
            detail:{},
            showAgreementPopup:false,
            agreementLoading:false,
            agreementHtml:''
        }
    },
    mixins:[myMixin],
    components:{
        BookingBack,
    },
    computed:{
        // 待审核(0)、审核通过(1)时表单只读
        isReadonly(){
            return this.status === 0 || this.status === 1
        }
    },
    created(){
        this.getSupplierApplyStatus()
    },
    methods:{
        getSupplierApplyStatus(){
            this.$api.getSupplierApplyStatus().then(res=>{
                // 接口返回 code: 1 表示成功
                if(res.code == 1 && res.data && res.data.detail){
                    this.detail = res.data.detail
                    this.status = res.data.detail.status
                    // 回填表单数据
                    this.form.store_name = res.data.detail.store_name || ''
                    this.form.tax_num = res.data.detail.tax_num || ''
                    this.form.bank_account = res.data.detail.bank_account || ''
                    this.form.business_id = res.data.detail.business_id || ''
                    // 回填Business License图片
                    if(res.data.detail.businessImage && res.data.detail.businessImage.file_path){
                        this.fileList = [{
                            url: this.getUrl(res.data.detail.businessImage.file_path),
                            file_id: res.data.detail.businessImage.file_id
                        }]
                    }
                }
            })
        },
        onSubmit(values){
            this.form.business_id = values.business_id[0].file_id
            this.$api.getSupplierApplyIndex(this.form).then(res=>{
                if(res.code == 1){
                    Toast('Application submitted. Please wait for review!')
                    this.getSupplierApplyStatus()
                }else{
                    Toast(res.msg)
                }
            })
        },
        handleRefresh(){
            // 重置为未申请状态，允许Refill
            this.status = null
            this.form = {
                store_name:'',
                tax_num:'',
                bank_account:'',
                business_id:''
            }
            this.fileList = []
        },
        afterRead(file){
            file.status = 'uploading'
            file.message = 'Uploading...'
            const fd = new FormData()
            fd.append('iFile', file.file,file.file.name)
            this.$api.uploadFile(fd).then(res=>{
                if(res.code == 1){
                    // 上传完毕
                    file.status = 'done'
                    file.message = ''
                    // 设置图片地址
                    file.file_id = res.data.file_id
                    // file.url = this.getUrl(res.data.file_path)
                    // file.file_path = this.getUrl(res.data.file_path)
                }else{
                    file.status = 'fail'
                    file.message = ''
                }
            })
        },
        onOversize(){
            Toast('File size cannot exceed 5000 KB')
        },
        async handleOpenMerchantAgreement(){
            this.showAgreementPopup = true
            if(this.agreementHtml){
                return
            }
            this.agreementLoading = true
            try{
                const res = await this.$api.getRegisterAgreements()
                if(res && res.code == 1){
                    const data = res.data || {}
                    this.agreementHtml = (data.merchant_agreement && data.merchant_agreement.merchant_agreement) || ""
                    if(!this.agreementHtml){
                        this.agreementHtml = "<p style=\"text-align:center;color:#999;\">No onboarding agreement content</p>"
                    }
                }else{
                    Toast((res && res.msg) || "Failed to load onboarding agreement")
                }
            }catch(e){
                Toast("Failed to load onboarding agreement")
            }finally{
                this.agreementLoading = false
            }
        }
    }
}
</script>
<style lang="scss" scoped>
    .settledPage{
        width: 100%;
        min-height: 100%;
        background: #F4F4F4;
    }
    .remark{
        font-size: .75rem;
        color: #999999;
        text-align: center;
        margin-top: 1rem;
        .remarkAgreement{
            color: #1E3C3E;
            text-decoration: underline;
        }
    }
    .settledForm{
        width: 100%;
        box-sizing: border-box;
        padding: 1rem;
    }
    .successCard{
        width: 100%;
        background: #EAFBF4;
        border-radius: .5rem;
        padding: 1.5rem 1rem;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-bottom: 1rem;
    }
    .successCard--inline{
        margin-bottom: 0.75rem;
    }
    .successIconOuter{
        width: 5.25rem;
        height: 5.25rem;
        border-radius: 50%;
        background: rgba(21, 196, 161, 0.18);
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .successIconInner{
        width: 3.75rem;
        height: 3.75rem;
        border-radius: 50%;
        background: #15C4A1;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .successText{
        margin-top: 1rem;
        color: #333;
        font-size: 0.9375rem;
        font-weight: 600;
    }
    .formCard{
        width: 100%;
        background: #fff;
        border-radius: .5rem;
        padding: 0.75rem;
        box-sizing: border-box;
        margin-bottom: 1rem;
    }
    .failTitle{
        font-size: .75rem;
        color: #999999;
        margin-bottom: 0.5rem;
    }
    .failError{
        width: 100%;
        padding: 1rem;
        margin:1rem 0;
        box-sizing: border-box;
        background: #F3F3F3;
        border-radius: .25rem;
        color: #666666;
    }
    .auditHint{
        width: 100%;
        height: 2.625rem;
        border-radius: .5rem;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #fff;
        font-size: .875rem;
        box-sizing: border-box;
        background: linear-gradient(90deg, #FFA800 0%, #FF8300 100%);
    }
    .refreshBtn{
        width: 100%;
        height: 2.625rem;
        border-radius: .25rem;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #333333;
        font-size: .875rem;
        border: 1px solid #EEEEEE;
        box-sizing: border-box;
        background: #fff;
    }
    .submitBtn{
        width: 100%;
        height: 2.625rem;
        border-radius: .25rem;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #fff;
        font-size: .875rem;
        border: 3px solid rgba(30, 60, 62, 0.20);
        box-sizing: border-box;
        background: #1E3C3E;
    }
    .uploaderBox{
        border: 1px solid #EEEEEE;
        border-radius: .5rem;
        margin: 0.5rem 0 1rem;
        width: 100%;
        box-sizing: border-box;
        padding: 0.5rem 0.5rem 0;
        .uploaderHeader{
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 0.25rem 0.25rem 0.5rem;
            box-sizing: border-box;
        }
        .uploaderlabel{
            font-size: .875rem;
            color: #666666;
        }
        .uploaderStatus{
            font-size: .875rem;
            font-weight: 600;
        }
        .uploaderStatusSpacer{
            width: 3.5rem;
            height: 1px;
            opacity: 0;
        }
    }
   .fieldInput{
        border: 1px solid #EEEEEE;
        border-radius: .5rem;
        margin-bottom: 1rem;
   }
   .van-cell::after{
    border-bottom:0 !important
   }
   .agreement{
        height: 100%;
        display: flex;
        flex-direction: column;
        padding: 1rem;
        box-sizing: border-box;
   }
   .agreementTitle{
        text-align: center;
        font-size: 1rem;
        font-weight: 600;
        margin-bottom: 0.75rem;
   }
   .agreementLoading{
        text-align: center;
        color: #999;
        padding-top: 1rem;
   }
   .agreementBody{
        flex: 1;
        overflow-y: auto;
        color: #333;
        font-size: .875rem;
        line-height: 1.6;
   }
   .agreementBody ::v-deep img{
        max-width: 100%;
        height: auto;
   }
</style>
